import React from 'react';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

const style = {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: 10000,
	background: 'rgba(0, 0, 0, 0.1)',
};

export default class FullScreenLoading extends React.Component {
	render() {
		return <div style={style}><LoadingIndicator /></div>
	}
}